import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'src/redux/store';
import axios from 'src/utils/axios';

const initialState = {
    isFaqGroupLoading: false,
    error: null,
    faqGroups: null,
    isPlanLoading: false,
    plans: null,
    isModuleLoading: false,
    modules: null,
};

const slice = createSlice({
    name: 'catalogApi',
    initialState,
    reducers: {
        // START LOADING
        startFaqGroupLoading(state) {
            state.isFaqGroupLoading = true;
        },
        startPlanLoading(state) {
            state.isPlanLoading = true;
        },
        startModuleLoading(state) {
            state.isModuleLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isFaqGroupLoading = false;
            state.isPlanLoading = false;
            state.error = action.payload;
        },
        // SET DATA
        setFaqGroups(state, action) {
            state.isFaqGroupLoading = false;
            state.faqGroups = action.payload;
        },
        setPlans(state, action) {
            state.isPlanLoading = false;
            state.plans = action.payload;
        },
        setModules(state, action) {
            state.isModuleLoading = false;
            state.modules = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startFaqGroupLoading,
    startPlanLoading,
    startModuleLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getFaqGroups() {
    return async () => {
        dispatch(slice.actions.startFaqGroupLoading());
        try {
            const response = await axios.get(`/api/catalog/faq_groups`);
            dispatch(slice.actions.setFaqGroups(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getPlans() {
    return async () => {
        dispatch(slice.actions.startPlanLoading());
        try {
            const response = await axios.get(`/api/catalog/plans`);
            dispatch(slice.actions.setPlans(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

